import CloseIcon from '@mui/icons-material/Close';
import { IconButton, IconButtonProps } from '@mui/material';
import clsx from 'clsx';

type CloseButtonProps = IconButtonProps & { filled?: boolean };

const CloseButton = ({ filled, ...props }: CloseButtonProps) => (
    <IconButton
        {...props}
        className={clsx('flex absolute top-1 right-1 md:right-5 md:top-5 z-10', props.className, {
            'text-white bg-primary-600 hover:bg-primary-700': filled,
        })}
    >
        <CloseIcon />
    </IconButton>
);

export { CloseButton };
